import {
  IFilter,
  round,
  IVisualizationState,
  IPeerGroupTabsProps,
  roundNumber,
} from "../../lib/http";
import * as React from "react";
import PanelGraph from "app/components/tabs/PanelGraph";

export class AssetAllocationEquities extends React.Component<
  IPeerGroupTabsProps,
  IVisualizationState
  > {
  state: IVisualizationState = {
    categories: [],
    data: [],
    series: [],
    filters: { assetLevel: -1 },
    title: "",
    loading: false,
    average: [],
    plotLineNumber: 0,
  };

  componentDidMount() {
    this.setState({ data: this.props.data }, () =>
      this.loadSeries(this.props.filters)
    );
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.filters.assetLevel !== this.props.filters.assetLevel ||
      prevProps.data.length !== this.props.data.length
    ) {
      this.setState(
        { filters: this.props.filters, data: this.props.data },
        () => {
          this.loadSeries(this.props.filters);
        }
      );
    }
  }

  loadSeries(filters: IFilter) {
    const { data } = this.state;

    const currentSet = data.find(
      (dataPoint) => dataPoint.filterId === filters.assetLevel
    );

    const filterOutAllFoundations = data.filter(
      (dataPoint) => dataPoint.filterId > 0
    );
    const filterOutAllFoundationsSize = filterOutAllFoundations.length;

    const categories = filterOutAllFoundations.map(
      (dataPoint) => dataPoint["Strat_T_V21_Col"]
    );

    const selectedLightColor = "#A9D08E";
    const selectedDarkColor = "#5E903C";
    const nonselectedLightColor = "#C6E0B4";
    const nonselectedDarkColor = "#A4CE88";

    const equitiesData = filterOutAllFoundations.map((dataPoint) =>
      dataPoint.filterId === filters.assetLevel
        ? {
            y: roundNumber(dataPoint["Strat_N_V21_AllocEqty"] * 100.0, 1),
            color: selectedLightColor,
          }
        : {
            y: roundNumber(dataPoint["Strat_N_V21_AllocEqty"] * 100.0, 1),
            color: nonselectedLightColor,
          }
    );

    const investmentsData = filterOutAllFoundations.map((dataPoint) =>
      dataPoint.filterId === filters.assetLevel
        ? {
            y: roundNumber(dataPoint["Strat_N_V21_AllocInvOth"] * 100.0, 1),
            color: selectedDarkColor,
          }
        : {
            y: roundNumber(dataPoint["Strat_N_V21_AllocInvOth"] * 100.0, 1),
            color: nonselectedDarkColor,
          }
    );

    const title = currentSet ? currentSet["Strat_T_V21_Vis21Title"] : "";
    const averageData = filterOutAllFoundations.map((dataPoint, index) => {
      const y = parseFloat(
        round(dataPoint.Strat_N_V21_AvgAllocEqtyandInvOth * 100.0, 1)
      );
      return index === filterOutAllFoundationsSize - 1
        ? { y: y, dataLabels: { enabled: true, format: "Average: {y}%" } }
        : y;
    });

    const series = [
      { color: "#A9D08E", name: "Investments - Other", data: investmentsData },
      { color: "#C6E0B4", name: "Equities", data: equitiesData },
      {
        color: "#a1a1a1",
        name: "Average",
        data: averageData,
        type: "line",
        dashStyle: "ShortDash",
        lineWidth: 3,
        marker: { enabled: false },
        showInLegend: false,
      },
    ];

    this.setState({ title, series, categories });
  }

  updateFilter(e) {
    if (this.props.onChangeFilterId) {
      this.props.onChangeFilterId(e.point.filterId);
    }
  }

  static getChartConfig(series, categories, title) {
    return {
      chart: { type: "column" },
      title: {
        text: title,
      },
      xAxis: {
        categories,
      },
      yAxis: {
        visible: true,
        opposite: true,
        title: "",
        labels: {
          format: "{value}%",
        },
      },
      plotOptions: {
        column: {
          stacking: "normal",
          dataLabels: {
            enabled: true,
            format: "{y:.1f}%",
          },
        },
      },
      legend: { enabled: true },
      credits: { enabled: false },
      series,
    };
  }

  render() {
    const { title, loading, series, categories } = this.state;
    return (
      <PanelGraph
        title=""
        loading={loading}
        chartConfig={AssetAllocationEquities.getChartConfig(
          series,
          categories,
          title
        )}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/visualizations/PeerGroups/AssetAllocation/AssetAllocationEquities/index.tsx